
export const formatDate = (date) => (
    months[date.month - 1] +
    " " +
    date.day +
    ", " +
    date.year +
    ""
);

const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];